function decimalise (value, decimalPlaces) {
  return parseFloat(Math.round(value * 100) / 100).toFixed(decimalPlaces)
}

export default function moneyString (value) {
  const money = decimalise(value, 2)
  return `${money}`
}
